import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { DirectivesModule } from '../../directives';
import { ExpressionEditorComponent } from './expression-editor.component';

@NgModule({
    imports: [TwcModule, FormsModule, CommonModule, TranslateModule, DirectivesModule],
    declarations: [ExpressionEditorComponent],
    exports: [ExpressionEditorComponent],
})
export class ExpressionEditorModule {}
